module.exports = __webpack_public_path__ + "static/img/scene4.79edf92f.jpg";